import * as React from 'react';
import { FavouriteLayoutComponentProps, FavouriteLayoutAttributes, FavouriteLayoutComponentState } from './types';
import { ChartFavouriteModelComponent } from './favourite/common/chart-favourite-model-component';
import { ChartLayoutConfig } from './favourite/common/layout-config';
import { createReactChartFavouriteModelComponent } from './favourite/react/react-favourite-model-component-factory';
import { chartType } from './constants';

export class ChartFavourite extends React.Component<FavouriteLayoutComponentProps, FavouriteLayoutComponentState> {
  private model: ChartFavouriteModelComponent;
  private ref: HTMLElement;
  constructor(props: FavouriteLayoutComponentProps) {
    super(props);
    this.model = this.prepareModel(props.layoutAttributes, props.intl, props.translation);
    this.state = { warningMessage: undefined };
  }

  private prepareModel(layoutAttributes: FavouriteLayoutAttributes, intl: any, translation: any) {
    return createReactChartFavouriteModelComponent(
      layoutAttributes,
      this.props.drillDown,
      this.props.caseview,
      intl,
      translation,
      null,
      this.props.numberOfGroupByFields
    );
  }

  private expandWidth = (props: FavouriteLayoutComponentProps) => {
    const { favouriteDataModel } = props;
    const isRiskMatrix = !!props.layoutAttributes['HighchartsStyle.heatmapUseDataPointColors'];

    if (this.getChartTypeFromConfig() === chartType.HEATMAP
      && favouriteDataModel
      && this.props.requestCustomWidth
      && !isRiskMatrix) {

      this.props.requestCustomWidth(favouriteDataModel.id, Math.ceil(favouriteDataModel.rows.length / 15) * 500);
    }
  };

  private beforePrint = () => {
    this.ref.classList.add('printing');
    this.model.reflowChart();
  };

  private afterPrint = () => {
    this.ref.classList.remove('printing');
    this.model.reflowChart();
  };

  public componentDidMount() {
    if (this.isChartTypeSupported() && this.props.favouriteDataModel) {
      this.model.receiveData(this.props.favouriteDataModel);
      this.expandWidth(this.props);
    }
    window.addEventListener('beforeprint', this.beforePrint);
    window.addEventListener('afterprint', this.afterPrint);
  }

  public componentDidUpdate(prevProps: FavouriteLayoutComponentProps) {
    let dirty: boolean = false;
    if (this.props.layoutAttributes) {
      if (prevProps.layoutAttributes !== this.props.layoutAttributes) {
        this.model.receiveLayout(this.props.layoutAttributes);
        dirty = true;
      }

      if (!this.props.fetchingDataModel && prevProps.favouriteDataModel !== this.props.favouriteDataModel) {

        this.expandWidth(this.props);
        this.model.receiveData(this.props.favouriteDataModel);
        dirty = true;
      }
    }

    if (prevProps.reflowHandle !== this.props.reflowHandle) {
      this.model.reflowChart();
    }

    if (dirty) {
      this.forceUpdate();
    }
  }

  public componentWillUnmount() {
    if (this.model) {
      //Destroy chart before unmount.
      this.model.destroy();
    }
    window.removeEventListener('beforeprint', this.beforePrint);
    window.removeEventListener('afterprint', this.afterPrint);
  }

  private getChartTypeFromConfig() {
    return (this.model.config as ChartLayoutConfig).chartType();
  }

  private isChartTypeSupported() {
    switch (this.getChartTypeFromConfig()) {
      case chartType.COLUMN:
      case chartType.PIE:
      case chartType.LINE:
      case chartType.BAR:
      case chartType.HEATMAP:
      case chartType.AREA:
        return true;
      default:
        return false;
    }
  }

  private onChartElementReady = (element: HTMLElement) => {
    //If a render has happened, this might be null for older callbacks.
    if (element) {
      this.ref = element;
      this.model.setChartElement(element);
      this.model.setChartWarningMessage = this.setWarningMessage;
    }
  };

  public setWarningMessage = (textWarning: string) => {
    this.setState({ warningMessage: textWarning });
  };

  public render() {
    const renderWarningMessage = () => {
      return !!this.state.warningMessage
        ? <div className="alert alert-warning"><p>{this.state.warningMessage}</p></div>
        : null;
    };

    return (
      this.isChartTypeSupported()
        ? <div>
          {renderWarningMessage()}
          <div ref={this.onChartElementReady} />
        </div>
        : <div>{this.props.translation.chart_not_supported_type}</div>
    );
  }
}
